import React, { useRef, useState } from 'react';

import Tooltip from '@mui/material/Tooltip';

export const OverflowTooltip = ({ title, children, ...tooltipProps }: any) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const ref = useRef<HTMLElement>(undefined);

  const checkOverflow = () => {
    const el = ref.current;
    if (!el) return;

    const isOverflowing = el.scrollWidth > el.clientWidth;
    setIsOverflow(isOverflowing);
  };

  React.useEffect(() => {
    const handle = requestAnimationFrame(checkOverflow);
    return () => cancelAnimationFrame(handle);
  }, []);

  const child = React.cloneElement(children, {
    ref: (node: HTMLElement) => {
      ref.current = node;
      if (typeof children.ref === 'function') children.ref(node);
      else if (children.ref) (children.ref as any).current = node;
    },
    onMouseEnter: (e: React.MouseEvent) => {
      checkOverflow();
      children.props.onMouseEnter?.(e);
    },
    onFocus: (e: React.FocusEvent) => {
      checkOverflow();
      children.props.onFocus?.(e);
    },
  });

  return isOverflow ? (
    <Tooltip title={title} {...tooltipProps}>
      {child}
    </Tooltip>
  ) : (
    child
  );
};
